import {LEPRECHAUNS_UNIT_SIZE_FOR_1_COIN_THEFT} from "../../configs/factions/leprechauns";

export const checkIfLeprechaunsUnitCouldSteal = (selectedUnit, otherPlayers) => {
  if (!selectedUnit || selectedUnit.size < LEPRECHAUNS_UNIT_SIZE_FOR_1_COIN_THEFT) {
    return false;
  }

  return otherPlayers.some(player => player.coins > 0);
}